// extracted by mini-css-extract-plugin
module.exports = {"Pricing":"styles_Pricing__IpWxo","card":"styles_card___lsaa","error":"styles_error__XLCFF","card-title":"styles_card-title__0VQ8e"};